<template>
  <div class="cover">
    <div class="meta">
      <div class="row justify-content-center mt-5">
        <div class="col-12 col-md-7 col-lg-5">
          <div class="titulo">
            <h2>{{ $t('cover.subtitle') }}</h2>
            <h1>{{ $t('cover.title') }}</h1>
          </div>          
        </div>      
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-md-7 col-lg-5">
          <div>
            <div class="mt-3 excerpt"><span>{{ $t('cover.description') }}</span></div>
          </div>          
          <div class="mt-5">
            <SocialSharing/>
          </div>
        </div>      
      </div>
    </div>
    <div class="cover-picture">
      <img width="100%" src="/fotos/FIX2_SeleccionVQS_2023_01.jpg" />
    </div>   
	</div>
</template>

<script>

  import SocialSharing from '@/components/SocialSharing.vue'

  export default {
    name: 'CoverHome',
    components: {
      SocialSharing
    }
  }
</script>

